import { useState } from 'react';

import { CopyrightFooter } from '@components/copyright-footer/copyright-footer';
import { Form, useFormContext } from '@components/form';
import { FormError } from '@components/form-error';
import { prepareFormData } from '@components/form/dynamic-fields';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';

import { FormResponse, useSaveForm } from 'api/form';

import { SubmissionSuccess } from './submission-success';

type DisplayFormProps = Pick<FormResponse, 'form' | 'application'> & {
  id: string;
};

export const DisplayForm = ({ form: initialForm, application, id }: DisplayFormProps) => {
  const submit = useSaveForm(id);
  const [form, setForm] = useState(initialForm);

  if (submit.isSuccess) {
    return <SubmissionSuccess />;
  }

  return (
    <Form
      space={6}
      onSubmit={(values) => submit.mutateAsync(prepareFormData(form, values, application))}
    >
      <Form.DynamicFields
        initialFields={form}
        externalConditionData={application}
        onFieldsUpdate={setForm}
      />
      <FormActions />
      <CopyrightFooter />
    </Form>
  );
};

export const FormActions = () => {
  const {
    store: { useFormHasErrors, useHasSubmit },
  } = useFormContext();
  const hasErrors = useFormHasErrors();
  const hasSubmit = useHasSubmit();
  const { t } = useScopedTranslate(translations);
  return (
    <div>
      <Form.Actions>
        <Form.Submit variant="custom" text={t('submit')} />
      </Form.Actions>
      <Stack space={0} align="flex-end">
        {hasSubmit && hasErrors && <FormError text={t('contains_errors')} />}
      </Stack>
    </div>
  );
};

const translations = {
  is: {
    submit: 'Senda svör',
    contains_errors: 'Ekki tókst að senda formið þar sem það inniheldur villur',
  },
  en: {
    submit: 'Send answers',
    contains_errors: 'Unable to send the form as it contains errors',
  },
  dk: {
    submit: 'Send svar',
    contains_errors: 'Formularen kunne ikke sendes, da den indeholder fejl',
  },
};
